/**
 * Horizontal product rails (Best Sellers + native peek carousels) must not
 * steal vertical page scrolling on touch. CSS uses touch-action: pan-y so the
 * browser keeps the page scroll, and this script only moves scrollLeft after
 * the gesture is clearly horizontal.
 */
(function () {
  'use strict';

  var LOCK = 8;
  var active = null;
  var suppressClick = false;

  function isRail(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute('data-cbs-viewport')) return true;
    if (el.classList.contains('slick-initialized')) return false;
    return el.hasAttribute('data-no-mobile-carousel') && !!el.closest('.product-carousel-peek');
  }

  function findRail(target) {
    if (!target || typeof target.closest !== 'function') return null;
    var node = target.closest('[data-cbs-viewport], [data-no-mobile-carousel]');
    return isRail(node) ? node : null;
  }

  function onPointerMove(event) {
    if (!active || event.pointerId !== active.id) return;

    var dx = event.clientX - active.x;
    var dy = event.clientY - active.y;

    if (!active.axis) {
      if (Math.abs(dx) < LOCK && Math.abs(dy) < LOCK) return;
      active.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (active.axis !== 'x') return;
      active.el.classList.add('is-dragging');
      try { active.el.setPointerCapture(event.pointerId); } catch (err) {}
    }

    if (active.axis !== 'x') return;
    if (event.cancelable) event.preventDefault();
    active.el.scrollLeft = active.scroll - dx;
  }

  function endGesture(event) {
    if (!active) return;
    if (event && typeof event.pointerId === 'number' && event.pointerId !== active.id) return;

    var el = active.el;
    var didDrag = active.axis === 'x';
    el.classList.remove('is-dragging');
    active = null;

    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', endGesture);
    window.removeEventListener('pointercancel', endGesture);

    if (!didDrag) return;
    suppressClick = true;
    window.setTimeout(function () {
      suppressClick = false;
    }, 80);
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse') return;
    if (event.isPrimary === false) return;
    if (event.target.closest('[data-cbs-prev], [data-cbs-next], input, select, textarea')) return;

    var el = findRail(event.target);
    if (!el) return;

    active = {
      el: el,
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      scroll: el.scrollLeft,
      axis: null
    };

    window.addEventListener('pointermove', onPointerMove, { passive: false });
    window.addEventListener('pointerup', endGesture);
    window.addEventListener('pointercancel', endGesture);
  });

  document.addEventListener('touchmove', function (event) {
    if (!active || active.axis !== 'x') return;
    if (event.cancelable) event.preventDefault();
  }, { passive: false });

  document.addEventListener('click', function (event) {
    if (!suppressClick) return;
    if (!findRail(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
  }, true);
})();
